<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    enable-background="new 0 0 21 21"
    xml:space="preserve"
  >
    <g id="icon">
      <path
        d="M16.7,19.5H4.3c-0.44,0,-0.8,-0.36,-0.8,-0.8V2.3c0,-0.44,0.36,-0.8,0.8,-0.8h12.4c0.44,0,0.8,0.36,0.8,0.8v16.4C17.5,19.14,17.14,19.5,16.7,19.5z"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M8,7.5h7.5M8,9.5h7.5M8,11.5h7.5M8,13.5h7.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <path
        d="M5.5,7.5h0.5M5.5,9.5h0.5M5.5,11.5h0.5M5.5,13.5h0.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <polyline
        points="14.5,15.5119 12.5497,17.5 11.5484,16.4987"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <rect
        x="5.5"
        y="3.5"
        width="10"
        height="1"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
